import * as api from "./client.js";

// wp-syncer registers GET /api/v1/quarantine with discovery; the staff-bff default convention
// projects it to /api/v1/wp-syncer/quarantine. The api client prepends the "/api" base.
const QUARANTINE_BASE = "/v1/wp-syncer/quarantine";

export type QuarantineCategory = "page-loss" | "photo/bio" | "firm-loss" | "re-key";

export type QuarantineFinding = {
  source_table: string;
  source_id: string;
  run_id: string;
  reason_class: string;
  reason: string;
  source_row: Record<string, unknown>;
  attempts: number;
  created_at: string;
  updated_at: string;
  resolved_at: string | null;
  parent_source_table: string | null;
  parent_source_id: string | null;
  disposition: string;
  page_exists: boolean | null;
  list_visible: boolean | null;
  flip_attribution: string | null;
  category: QuarantineCategory;
  name: string;
  firm: string | null;
  urls: { url: string } | { old_url: string; new_url: string };
  match_basis?: string;
  why: string;
  fix: string;
  status: "needs_redirect" | "resolved" | "open";
};

export type QuarantineCounts = Record<QuarantineCategory, { open: number; resolved: number }>;

export type ListQuarantineResponse = {
  rows: QuarantineFinding[];
  counts: QuarantineCounts;
  all: number;
  delta: Record<QuarantineCategory, number>;
  previous_run_started_at: string | null;
  pagination: { total: number; limit: number; offset: number; has_more: boolean };
  request_id: string;
};

export type QuarantineFilters = {
  category?: QuarantineCategory;
  disposition?: string;
  q?: string;
  limit?: number;
  offset?: number;
};

export const quarantineService = {
  listQuarantine(filters: QuarantineFilters = {}): Promise<ListQuarantineResponse> {
    const params = new URLSearchParams();
    if (filters.category) params.set("category", filters.category);
    if (filters.disposition) params.set("disposition", filters.disposition);
    if (filters.q) params.set("q", filters.q);
    if (filters.limit != null) params.set("limit", String(filters.limit));
    if (filters.offset != null) params.set("offset", String(filters.offset));
    const qs = params.toString();
    return api.get<ListQuarantineResponse>(`${QUARANTINE_BASE}${qs ? `?${qs}` : ""}`);
  },
};
